import { MutationTree } from 'vuex'
import { IScheduleState } from '@/store/schedule'
import { Types, Store, Current, Query, Type, ScrollTop, Count } from '@/store/schedule/types'

const mutations: MutationTree<IScheduleState> = {
  [Types.store]: (state, action: Store) => {
    state.response = action.payload
  },
  [Types.current]: (state, action: Current) => {
    state.current = action.payload
  },
  [Types.query]: (state, action: Query) => {
    state.query = action.payload
  },
  [Types.type]: (state, action: Type) => {
    state.type = action.payload
  },
  [Types.scrollTop]: (state, action: ScrollTop) => {
    state.scrollTop = action.payload
  },
  [Types.count]: (state, action: Count) => {
    state.count = action.payload
  }
}

export default mutations
